function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownload = function SvgDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 35.47 35",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    d: "M31.27,20.91h-5a1.23,1.23,0,1,0,0,2.46h5A1.74,1.74,0,0,1,33,25.11V30.8a1.74,1.74,0,0,1-1.74,1.74H4.2A1.74,1.74,0,0,1,2.46,30.8V25.11A1.74,1.74,0,0,1,4.2,23.37H8.86a1.23,1.23,0,0,0,0-2.46H4.2A4.21,4.21,0,0,0,0,25.11V30.8A4.2,4.2,0,0,0,4.2,35H31.27a4.21,4.21,0,0,0,4.2-4.2V25.11A4.21,4.21,0,0,0,31.27,20.91Z",
    style: {
      fill: "inherit",
      stroke: "none"
    }
  }), React.createElement("path", {
    d: "M16.73,26.13a1.22,1.22,0,0,0,1,.53,1.24,1.24,0,0,0,1-.53l10-14.34a1.23,1.23,0,0,0-1-1.93H21.63V1.23A1.23,1.23,0,0,0,20.4,0H15.07a1.23,1.23,0,0,0-1.23,1.23V9.86H7.78a1.24,1.24,0,0,0-1.09.66,1.19,1.19,0,0,0,.08,1.27ZM15.07,12.32a1.23,1.23,0,0,0,1.23-1.23V2.46h2.87v8.63a1.23,1.23,0,0,0,1.23,1.23h4.94l-7.6,11L10.13,12.32Z",
    style: {
      fill: "inherit",
      stroke: "none"
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/download.96f6fafb.svg";
export { ForwardRef as ReactComponent };